import { render } from "./content-card.vue?vue&type=template&id=5c50d2d6"
import script from "./content-card.vue?vue&type=script&lang=js"
export * from "./content-card.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__